module.exports = __webpack_public_path__ + "static/media/team.3ee04b86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutUs/images/team.jpg
// module id = 113
// module chunks = 0